

export const atonlineEnData = ` 
<div class="page-title">TERMS AND CONDITIONS</div>
<div class="paragraph">
    <div class="text-box">
      <div class="text">
      This buy-back or “Trade-In” service (hereinafter, the “Service”) is provided by Danghuan Europe S.L., a company incorporated under Spanish law, with registered address in Madrid, Spain (28045) and Tax Identification Number B19961911 (hereinafter, “Danghuan”), email legal@danghuan.eu. VBF Tech Austria GmbH (hereinafter, “vivo Austria”), promote the availability of this Service on their official websites. However, vivo Austria does not operate, administer, or directly manage the buy-back program. All transactions, device inspections, and payments related to the Service are managed exclusively by Danghuan Europe S.L.
      </div>
      <div class="text">
      This document governs the terms and conditions under which consumers residing in the European Union may participate in the official buy-back program linked to the purchase of certain eligible vivo electronic devices. The program is carried out in full compliance with European Union legislation, in particular Directive 2011/83/EU on consumer rights, Directive 93/13/EEC on unfair terms in consumer contracts, and Regulation (EU) 2016/679 on the protection of personal data (GDPR).
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 1 – TERRITORIAL SCOPE AND PRODUCTS</div>
    <div class="text-box">
      <div class="text">
      1.1. The Service is available to natural persons over 18 years of age who legally reside in a Member State of the European Union. However, the Service is not available in island territories, outermost regions or areas subject to special customs regimes or logistical restrictions, including, among others, the Canary Islands, the Balearic Islands, Ceuta and Melilla.
      </div>
      <div class="text">
      1.2. Customers must act in a personal (non-professional) capacity and qualify as a “consumer” under Directive 2011/83/EU.
      </div>
      <div class="text">
      1.3. Each Trade-In transaction allows the submission of a single (1) used device. In order to prevent abusive use of the program, Danghuan reserves the right to limit the number of Trade-In transactions per user. In particular:<br>
      i) The same user may carry out up to three (3) Trade-In transactions linked to the purchase of the same model of new product.<br>
      ii) The same user may carry out a maximum of twelve (12) Trade-In transactions in total across the different eligible product pages.<br>
      iii) Danghuan may verify the identity of the user and the device through its serial number (S/N), IMEI or other technical identifiers.<br>
      iv) Danghuan reserves the right to limit the number of transactions whenever necessary in order to prevent abusive use of the program.
      </div>
      <div class="text">
      1.4. The Service is offered exclusively to customers who purchase eligible vivo Austria products (“Product”) through the official vivo Austria online stores in Europe during the applicable campaign period. Only certain vivo Austria models may participate in the program.
      </div>
      <div class="text">
      1.5. The device submitted must appear among the eligible models published on the official website of the Service and must comply with the functionality and ownership criteria detailed in Article 5.
      </div>
      <div class="text">
      1.6. The customer may submit a single (1) used device for each Product purchased.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 2 – CONTRACTUAL CONDITIONS</div>
    <div class="text-box">
      <div class="text">
      2.1. The Service operates independently from the purchase of any Product and does not constitute a combined offer nor a contractual obligation linked to the purchase of the Product or linked to any manufacturer, distributor or retailer.
      </div>
      <div class="text">
      2.2. All operational responsibility for the Service, including communication with the customer, logistics, valuation, payments and the processing of personal data, rests exclusively with Danghuan Europe S.L.
      </div>
      <div class="text">
      2.3. Nothing in these Terms limits or diminishes the legal rights of the consumer recognised by applicable legislation, including, among others, Directive 2011/83/EU and Directive 93/13/EEC.
      </div>
      <div class="text">
      2.4. Danghuan reserves the right to reject any buy-back request where there are reasonable indications of fraud, abuse or breach of these conditions, including cases in which the request is submitted by a third party on behalf of another user.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 3 – SERVICE PARTICIPATION PROCESS</div>
    <div class="text-box">
      <div class="text">
      3.1. Customers may enrol in the buy-back Service during the purchase process in the vivo Austria online store.
      </div>
      <div class="text">
      3.2. To proceed, they must complete a self-assessment questionnaire and enter the device details (IMEI, model and condition and other relevant characteristics).<br>
      • Please ensure that the model of your old device is selected correctly. If any change is required, please contact us as soon as possible at vivo-at@danghuan.eu so that we can update the device information.
      </div>
      <div class="text">
      3.3. At the time of registration, valid bank details must be provided for payment:<br>
      • Residents in the EU/European Economic Area: SEPA-compatible IBAN account.<br>
      • The bank details will be used exclusively for the execution of payment for the Service.
      </div>
      <div class="text">
      3.4. The customer will receive an email with the shipping instructions within approximately 24 hours after confirmation of the shipment of the new device.
      </div>
      <div class="text">
      3.5. The used device must be shipped within twenty (20) calendar days after placing the order for the new product. The shipment must include a valid tracking number generated within that period.
      </div>
      <div class="text">
      3.6. Failure to complete these steps within the established period may result in the automatic cancellation of the Trade-In request, without entitlement to compensation.
      </div>
      <div class="text">
      3.7. Incomplete requests or those containing inconsistent data (for example, non-matching IMEI or serial number (S/N) or missing documentation) may be rejected without compensation. The device may be returned to the customer in accordance with the applicable return conditions.
      </div>
      <div class="text">
      3.8. The device must be packaged securely in accordance with the instructions provided. Shipping is prepaid by Danghuan. In case of loss or damage during transport, the customer must contact vivo-at@danghuan.eu within 15 calendar days from the last tracking update. Danghuan will provide access to the official UPS claims channel and assist the customer in the process. Logistics claims must be submitted within 60 days following the creation of the shipping label.<br>
      Any approved compensation will be paid directly to the indicated IBAN account. Danghuan assumes no additional responsibility beyond the claims procedures established by the carrier.
      </div>
      <div class="text">
      3.9. Devices sent without the integrity declaration or without the signed sales confirmation will not be processed. The customer will be notified by email and may request their return within 10 calendar days from the notification. Return costs will apply according to Article 6.3. If no request is received within that period, Danghuan may recycle or dispose of the device responsibly after prior notification to the customer.
      </div>
      <div class="text">
      3.10. Devices accepted for buy-back will include certain eligible electronic products in accordance with the list published on the official website of the Service.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 4 – DEVICE ACCEPTANCE CONDITIONS</div>
    <div class="text-box">
      <div class="text">
      4.1. Only devices included in the list of eligible models published on the vivo Austria Service website will be accepted.
      </div>
      <div class="text">
      4.2. All devices must comply with the valuation standards and cosmetic condition defined by Danghuan. They will be classified as Grade A, B or C according to certified inspection tools and the physical condition of the device, in accordance with Article 6. The final classification will be determined following the technical inspection carried out by Danghuan.
      </div>
      <div class="text">
      4.3. All devices must comply with the following minimum functionality and condition requirements according to their category:<br>
      – Smartphones: They must power on correctly, have a functional touchscreen and battery, show no serious damage (for example, broken screen or corrosion), and be completely restored to factory settings with all lock functions disabled (PIN, Apple iCloud, Google FRP, Samsung, Xiaomi, or other account lock systems).<br>
      Danghuan reserves the right to reject devices that do not meet these minimum requirements following technical inspection.
      </div>
      <div class="text">
      4.4. Devices must be the exclusive property of the customer and must not be subject to leasing, financing or third-party rights. Devices reported as lost, stolen, counterfeit or tampered with (e.g. altered IMEI) will not be eligible for compensation.
      </div>
      <div class="text">
      4.5. Devices that do not meet the minimum criteria may be returned if the customer requests this within seven (7) calendar days following the notification (sent by email). Otherwise, and after prior notification to the customer, the device may be recycled or disposed of responsibly.<br>
      The return will be governed by the same conditions and costs established in Article 6.3.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 5 – LOGISTICS TIMELINE AND OBLIGATIONS</div>
    <div class="text-box">
      <div class="text">
      5.1. The customer must send the used device within a maximum period of ten (10) calendar days from receipt of the newly purchased vivo Austria product.
      </div>
      <div class="text">
      5.2. Danghuan will send automatic reminders to the customer during the device shipment period on day three (3) (D+3), day six (6) (D+6) and day nine (9) (D+9) after delivery.
      </div>
      <div class="text">
      5.3. All shipments must be made using the prepaid shipping label provided by Danghuan Europe S.L.
      </div>
      <div class="text">
      5.4. If the label is not scanned by the carrier within the established period for sending the used device, Danghuan may automatically cancel the buy-back request.
      </div>
      <div class="text">
      5.5. The customer must package the device securely to prevent damage during transport. Danghuan will provide packaging instructions but not physical materials. The customer will be responsible for damage resulting from inadequate packaging.
      </div>
      <div class="text">
      5.6. If the received device presents a non-matching IMEI or a condition different from that declared, Danghuan may adjust the valuation or cancel the transaction in accordance with these Conditions.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 6 – INSPECTION, QUOTATION, ACCEPTANCE</div>
    <div class="text-box">
      <div class="text">
      6.1. Devices will be inspected within three (3) business days following their receipt at the designated warehouse. The inspection includes a functional review using certified tools and a visual evaluation of the cosmetic condition (Grade A, B or C).
      </div>
      <div class="text">
      6.2. If the condition of the device does not match the information provided by the customer, Danghuan will send a new adjusted offer (revised quotation) by email, indicating the new grade and its justification.
      </div>
      <div class="text">
      6.3. The customer will have five (5) calendar days from notification to accept or reject the new valuation and may request the return of the device.<br>
      • All customers: the customer is responsible for paying the return shipping cost, up to a maximum of €22 EUR, using the official prepaid return label provided by Danghuan. Payment details will be provided by Danghuan upon request by the customer or included in the email containing the payment link.<br>
      The customer may pay the return shipping costs through:<br>
      • SEPA transfer (for EU/EEA customers) to Danghuan's IBAN.<br>
      If payment is not received within fifteen (15) calendar days from the date the payment request is sent, storage fees of up to €0.80 per day will apply starting from day sixteen (16). If the return shipping cost and the accumulated storage fees remain unpaid forty-five (45) calendar days after the rejection date, the device will be considered abandoned by the customer (after prior notification to the customer). In such case, Danghuan will assume full responsibility for the device and will have the right to manage, dispose of, recycle, resell or otherwise handle the device in any manner deemed appropriate, in accordance with applicable environmental laws and regulations, without generating any further obligations, notifications or compensation to the customer.<br>
      Once Danghuan receives the return shipping cost and any applicable storage fees (if applicable) paid by the customer, DANGHUAN will return the customer's device within five (5) business days.
      </div>
      <div class="text">
      6.4. If the customer does not respond to the revised quotation within three (3) calendar days, Danghuan customer service will attempt to contact the customer directly to confirm acceptance or rejection. Such contact attempt will not suspend or extend the five (5) calendar day period. If the customer neither expressly accepts nor rejects the revised quotation within the five (5) calendar day period, Danghuan may proceed with payment in accordance with the final revised valuation.
      </div>
      <div class="text">
      6.5. Devices considered non-eligible due to irreparable damage, tampering or ineligibility (for example, iCloud lock, theft, non-matching IMEI or serial number (S/N) or irreparable structural damage) will receive no valuation. Customers will have seven (7) calendar days from notification to request their return; otherwise the device will be responsibly recycled.
      </div>
      <div class="text">
      6.6. Payment for accepted devices will be made within three (3) business days from the date of acceptance, by SEPA transfer.
      </div>
      <div class="text">
      6.7. Device valuation criteria:<br>
      Devices (smartphone, action camera) is subject to specific requirements:
      </div>
      <div class="text1">
      I.Smartphones
      </div>
      <div class="text1">
      Grade A – Excellent Condition
      </div>
      <div class="text2">
      • Device shows normal signs of use but remains in good condition.
      </div>
      <div class="text2">
      • No cracks, dents, or paint loss.
      </div>
      <div class="text2">
      • All functions (screen, touch, camera, buttons, speaker, battery, connectivity, etc.) operate normally.
      </div>
      <div class="text2">
      • For Apple devices, battery health ≥ 90%.
      </div>
      <div class="text1">
      Grade B – Light Signs of Use
      </div>
      <div class="text2">
      • Device shows normal signs of use but remains in good condition.
      </div>
      <div class="text2">
      • May have 2–3 minor scratches or small scuffs; no major damage.
      </div>
      <div class="text2">
      • All key functions (display, touch, sensors, Bluetooth) operate normally.
      </div>
      <div class="text2">
      • For Apple devices, battery health ≥ 80%
      </div>
      <div class="text1">
      Grade C – Visible Signs of Use
      </div>
      <div class="text2">
      • Device exhibits visible and more pronounced signs of wear, such as multiple scratches, paint wear, or a small dent.
      </div>
      <div class="text2">
      • A light crack on the screen is acceptable if functionality is not affected.
      </div>
      <div class="text2">
      • All key functions (screen, touch, camera, connectivity) remain operational.
      </div>
      <div class="text1">
      Grade D – Non-recoverable / Rejected
      </div>
      <div class="text2">
      • Device is severely damaged or cannot power on.
      </div>
      <div class="text2">
      • Deep cracks, bent frame, broken screen or housing, missing parts, motherboard failure, corrosion, no display or touch response.
      </div>
      <div class="text2">
      • Device cannot be connected or tested (e.g., locked by Google / iCloud / PIN).
      </div>
      <div class="text2">
      • The device battery is swollen, or has other issues that do not meet safety inspection standards, such as excessive overheating or the housing being pushed open by the battery.
      </div>
      <div class="text">
      The above descriptions are indicative and illustrative. The final classification will be determined exclusively by Danghuan following the technical inspection of the old device carried out at the designated warehouse.
      </div>
      <div class="text">
      6.8. If the device received does not significantly match the model or IMEI declared by the customer, Danghuan will contact the customer to inform them of the new offer. If the device received is eligible for the buy-back program, a new valuation will be issued based on its actual condition.<br>
      The customer must review and accept the new valuation and sign a new Declaration of Ownership and Integrity corresponding to the received device before continuing with the process.<br>
      If the customer does not accept the new offer within five (5) calendar days, the customer may request the return of the device in accordance with the conditions described in Article 6.3.
      </div>
      <div class="text">
      6.9. The buy-back process requires the customer to sign and submit the Declaration of Ownership and Integrity of the device. Failure to submit or sign this document may result in the rejection of the buy-back request. In such case, the device may be returned to the customer upon request in accordance with Article 6.3 or responsibly recycled if no response is received within the corresponding time period.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 7 – PAYMENT CONDITIONS</div>
    <div class="text-box">
      <div class="text">
      7.1. Payments will be made exclusively by bank transfer to an account in the name of the customer, as indicated during the registration of the buy-back process.
      </div>
      <div class="text">
      7.2. For customers residing in the European Union or the European Economic Area, payment will be made by SEPA transfer to an IBAN issued by a valid financial institution within the SEPA zone.
      </div>
      <div class="text">
      7.3. Prepaid cards, virtual accounts or bank details that do not match the registered account holder of the customer will result in payment failure and may lead to the cancellation of the buy-back transaction.
      </div>
      <div class="text">
      7.4. Danghuan will not be responsible for delays or errors caused by incomplete, incorrect or expired banking details.
      </div>
      <div class="text">
      7.5. If the customer provides incorrect, invalid or mismatched bank details and the payment is successfully processed to the provided account, Danghuan will not assume responsibility for any resulting loss. The customer acknowledges full responsibility for ensuring the accuracy of their banking information. In such cases, no second payment will be issued.
      </div>
      <div class="text">
      7.6. Once the buy-back process has been completed, if the refundable amount specified in the order is lower than the applicable trade-in bonus amount, only the residual refundable amount will be paid.
      </div>
      <div class="text">
      7.7. The trade-in bonus (if applicable) will be cancelled in the event of a refund of the Product order.
      </div>
      <div class="text">
      7.8. All bank fees or charges related to buy-back payments will be borne by Danghuan.
      </div>
      <div class="text">
      7.9. The total amount payable to the customer may consist of two separate transfers:<br>
      (a) the value of the submitted device, paid directly by Danghuan; and<br>
      (b) any applicable promotional bonus granted by vivo Austria, paid separately by vivo Austria to the same bank details provided by the customer.<br>
      Both payments may be received at different times depending on the processing timelines of each party.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 8 – LIABILITY AND RISK OF LOSS</div>
    <div class="text-box">
      <div class="text">
      8.1. Customers must use the prepaid shipping label and the carrier designated by Danghuan. Any alternative shipping method will void the liability coverage.
      </div>
      <div class="text">
      8.2. A device will be considered lost if it is not tracked, confirmed or received by Danghuan within fifteen (15) calendar days from the date of handover to the carrier.<br>
      • For shipments made with UPS, claims must be submitted within sixty (60) days following the creation of the shipping label.<br>
      Danghuan will assist customers in the claims process with the courier service, which generally takes between thirty (30) and sixty (60) days.
      </div>
      <div class="text">
      8.3. This liability framework applies equally to shipments from the customer to Danghuan and to return shipments from Danghuan Europe S.L. to the customer.
      </div>
      <div class="text">
      8.4. If a shipment loss is confirmed under Danghuan's logistics system, Danghuan will assist the customer in submitting a formal claim to the relevant courier service.
      </div>
      <div class="text">
      8.5. Liability and compensation are strictly limited to cases where the customer has used the authorised shipping label provided by Danghuan and the shipping event can be verified.
      </div>
      <div class="text">
      8.6. In such confirmed loss cases, compensation will not exceed the final valuation amount of the old device, determined prior to confirmation of the loss.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 9 – PERSONAL DATA AND GDPR COMPLIANCE</div>
    <div class="text-box">
      <div class="text">
      9.1. All personal data provided by customers during their participation in the Trade-In program will be processed in accordance with applicable data protection legislation, including Regulation (EU) 2016/679 (General Data Protection Regulation – GDPR) for residents in the European Union.<br>
      Danghuan acts as the data controller (Data Controller) and adopts appropriate technical and organisational measures to ensure the confidentiality, integrity and security of all personal data processed within the framework of the Buy-Back Program.
      </div>
      <div class="text">
      9.2. The data collected includes, among others: name, surname, email address, postal address, telephone number, bank account, identification documents, IMEI or serial number (S/N) of the submitted device and responses provided in the evaluation form.
      </div>
      <div class="text">
      9.3. The data will be used solely for the following purposes: identity verification, fraud prevention, management and evaluation of the buy-back request, organisation of the collection and shipment of the device, customer service, accounting and execution of payments. Personal data will not be used for commercial purposes nor shared with third parties without explicit consent, except where there is a legal obligation.
      </div>
      <div class="text">
      9.4. The data will be retained only for the time necessary to complete the buy-back transaction and comply with applicable legal obligations. As a general rule, all customer data will be deleted within two (2) years after completion of the buy-back process and the corresponding payment. However, certain data may be retained for up to a maximum of three (3) years where necessary for audits, payment reconciliations, fraud investigations or reviews by brand partners, in accordance with data protection regulations.
      </div>
      <div class="text">
      9.5. The customer is solely responsible for securely deleting all personal information from the device before sending it. This includes contacts, messages, photographs, applications, emails, browsing history, accounts and any other confidential content.
      </div>
      <div class="text">
      9.6. The customer must also remove any SIM card, external memory cards or microSD cards and deactivate all security functions, such as screen locks, passwords and linked accounts (for example Apple iCloud, Google or Samsung Find My Mobile). Failure to comply with this obligation may result in the device being considered not eligible for the buy-back.
      </div>
      <div class="text">
      9.7. Additional information regarding the processing of personal data and customer rights (access, rectification, erasure, restriction, objection and portability) is available in the Privacy Policy published on Danghuan's official website.
      </div>
      <div class="text">
      9.8. The Customer also has the right to lodge a complaint with the competent data protection authority in their country of residence.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 10 – FRAUD AND NON-COMPLIANCE POLICY</div>
    <div class="text-box">
      <div class="text">
      10.1. Requests containing false declarations or including devices listed as stolen, leased, tampered with or not the legitimate property of the applicant may be disqualified without entitlement to any compensation.
      </div>
      <div class="text">
      10.2. Danghuan reserves the right to exclude such participants from any current or future Trade-In program where there are reasonable indications of fraud or breach of these Conditions.
      </div>
      <div class="text">
      10.3. In cases where fraud, identity theft or attempts to circumvent eligibility criteria for commercial purposes are detected, Danghuan reserves the right to initiate the corresponding legal actions.
      </div>
      <div class="text">
      10.4. In cases of confirmed fraud, Danghuan may cooperate and share information with the competent authorities in accordance with applicable legislation.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 11 – FORCE MAJEURE</div>
    <div class="text-box">
      <div class="text">
      11.1. In the event of natural disasters, governmental restrictions, pandemics, labour disputes or transport disruptions that are beyond Danghuan's reasonable control, Danghuan may reasonably and temporarily suspend the Trade-In service without generating any liability for damages.
      </div>
      <div class="text">
      11.2. Any delay or failure resulting from such force majeure circumstances will not be considered a contractual breach.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 12 – GOVERNING LAW AND JURISDICTION</div>
    <div class="text-box">
      <div class="text">
      12.1. These Terms and Conditions will be governed by and interpreted in accordance with the laws of Spain. Nothing contained in this document will affect the consumer protection rights recognised under the legislation of the customer's country of residence.
      </div>
      <div class="text">
      12.2. Any dispute arising from or related to these Terms and Conditions will be subject to the exclusive jurisdiction of the courts of Madrid, Spain, without prejudice to the consumer's right to bring actions before the courts of their place of residence.
      </div>
    </div>
  </div>

<div class="paragraph">
    <div class="title">ARTICLE 13 – MODIFICATION OF THE TERMS</div>
    <div class="text-box">
      <div class="text">
      13.1. Danghuan reserves the right to modify these Terms and Conditions at any time.
      </div>
      <div class="text">
      13.2. The modifications will be published on the official website and will apply from the date of publication.
      </div>
    </div>
  </div>
`